//! PLEASE keep this list in alphabetical order for a better readability
export enum JOURNEY_ADMIN {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=594672619
     */
    AUTHORIZED_SENDING_DAYS = 'JOURNEY_ADMIN.AUTHORIZED_SENDING_DAYS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=594700910
     */
    AUTHORIZED_SENDING_DAYS_DESCRIPTION = 'JOURNEY_ADMIN.AUTHORIZED_SENDING_DAYS_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=595626112
     */
    AUTHORIZED_SENDING_DAYS_ERROR = 'JOURNEY_ADMIN.AUTHORIZED_SENDING_DAYS_ERROR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=213701111
     */
    BASELINE_DESCRIPTION = 'JOURNEY_ADMIN.BASELINE.DATE.DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=216193735
     */
    BASELINE_PLACEHOLDER = 'JOURNEY_ADMIN.BASELINE.DATE.PLACEHOLDER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=460498836
     */
    DELETE_CONFIRMATION_DESCRIPTION = 'JOURNEY_ADMIN.DELETE_CONFIRMATION_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=460505179
     */
    DELETE_CONFIRMATION_TITLE = 'JOURNEY_ADMIN.DELETE_CONFIRMATION_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=487213823
     */
    DELETE_STAKEHOLDER_DIALOG_TITLE = 'JOURNEY_ADMIN.DELETE_STAKEHOLDER_DIALOG_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=487216000
     */
    DELETE_STAKEHOLDER_DIALOG_MESSAGE = 'JOURNEY_ADMIN.DELETE_STAKEHOLDER_DIALOG_MESSAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=213401537
     */
    DESCRIPTION_PLACEHOLDER = 'JOURNEY_ADMIN.DESCRIPTION.PLACEHOLDER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=431833153
     */
    EMPTY_DESCRIPTION = 'JOURNEY_ADMIN.EMPTY_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=601836148
     */
    EMPTY_FEATURED_IMAGE = 'JOURNEY_ADMIN.EMPTY_FEATURED_IMAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=428219791
     */
    EMPTY_STAKEHOLDERS = 'JOURNEY_ADMIN.EMPTY_STAKEHOLDERS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=215413172
     */
    EMPTY_STATE_TITLE = 'JOURNEY_ADMIN.EMPTY_STATE_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=215448535
     */
    ENROLLED_USERS = 'ENROLLMENTS.ENROLLED_USERS',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13454334
     */
    FEATURED_IMAGE = 'WIDGET_TYPE_FEATURED-IMAGE_PLACEHOLDER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=600090622
     */
    FEATURED_IMAGE_DESCRIPTION = 'JOURNEY_ADMIN.FEATURED_IMAGE_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=215449608
     */
    ITEMS = 'ITEM_CONFIGURATIONS.ITEMS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=215426405
     */
    JOURNEY_ITEMS = 'JOURNEY_ADMIN.ITEM',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=214893783
     */
    JOURNEY_CREATED = 'JOURNEY_ADMIN.ALERT.CREATED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=460505921
     */
    JOURNEY_DELETED = 'JOURNEY_ADMIN.JOURNEY_DELETED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=222443525
     */
    JOURNEY_DUPLICATED = 'JOURNEY_ADMIN.DUPLICATED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=558281844
     */
    NAME_LABEL = 'JOURNEY_ADMIN.NAME_LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=558283000
     */
    NAME_LABEL_WITH_LANG = 'JOURNEY_ADMIN.NAME_LABEL_WITH_LANG',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=213390153
     */
    NAME_PLACEHOLDER = 'JOURNEY_ADMIN.NAME.PLACEHOLDER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=213134123
     */
    NEW_JOURNEY = 'JOURNEY_ADMIN.NEW_JOURNEY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=431837628
     */
    NEW_STAKEHOLDER = 'JOURNEY_ADMIN.NEW_STAKEHOLDER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=428608538
     */
    PROFILE_NAME = 'JOURNEY_ADMIN.PROFILE_NAME',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=353465900
     */
    SETTINGS = 'JOURNEY_ADMIN.SETTINGS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=644002517
     */
    SIDE_NAV_TITLE = 'JOURNEY_ADMIN.SIDE_NAV_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=431837409
     */
    STAKEHOLDER_DESCRIPTION = 'JOURNEY_ADMIN.STAKEHOLDER_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=435297099
     */
    STAKEHOLDER_LABEL_ERROR = 'JOURNEY_ADMIN.STAKEHOLDER_LABEL_ERROR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=428236158
     */
    STAKEHOLDER_LABEL_HELPER = 'JOURNEY_ADMIN.STAKEHOLDER_LABEL_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=432355397
     */
    STAKEHOLDER_MAX_LIMIT_MESSAGE = 'JOURNEY_ADMIN.STAKEHOLDER_MAX_LIMIT_MESSAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=432332573
     */
    STAKEHOLDER_USERPROFILE_FIELD_HELPER = 'JOURNEY_ADMIN.STAKEHOLDER_USERPROFILE_FIELD_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=434946777
     */
    STAKEHOLDER_USERPROFILE_FIELD_NOT_EDITABLE = 'JOURNEY_ADMIN.STAKEHOLDER_USERPROFILE_FIELD_NOT_EDITABLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=432332707
     */
    STAKEHOLDER_USERPROFILE_FIELD_PLACEHOLDER = 'JOURNEY_ADMIN.STAKEHOLDER_USERPROFILE_FIELD_PLACEHOLDER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=526641588
     */
    VISIBILITY_HELPER = 'JOURNEY_ADMIN.VISIBILITY_HELPER',
}
